import api from '@/services/api'

export const getGeneralComments = async (
    currentUserId,
    commentedUserId,
    periods
) => {
    try {
        const resp = await api.get(`/general-comment/${commentedUserId}`, {
            params: {
                periods: periods,
                userId: currentUserId,
            },
        })

        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

export const createGeneralComment = async data => {
    try {
        return await api.post('/general-comment', data)
    } catch (error) {
        console.error(error)
    }
}

export const updateGeneralComment = async (id, comment) => {
    try {
        return await api.put(`/general-comment/${id}`, {
            id,
            comment,
        })
    } catch (error) {
        console.error(error)
    }
}

export const deleteGeneralComment = async id => {
    try {
        return await api.delete(`/general-comment/${id}`)
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const deleteNBoxComment = async id => {
    try {
        return await api.delete(`n-box-comments/${id}`)
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const getUserNBoxComments = async (userId, periods) => {
    try {
        const resp = await api.get('n-box-comments', {
            params: {
                with: 'valuer;nBox',
                filter:
                    'id;content;created_at;n_box_id;valuer_id;valuer.name;valuer.picture;nBox.title',
                search: `evaluated_id:${userId}`,
                and: 'yes',
                orderBy: 'created_at',
                sortedBy: 'desc',
                scopes_names: ['of_periods'],
                periods,
            },
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}
